import { util, getProperty } from './util';
import { api } from './api';
import WorkDatesService from '../../services/WorkDates';
import _ from 'lodash';

/**
 * APIからの戻り値に対して日付配列を取得する関数
 * 戻り値は [{'2019/05/30':true}, {'2019/05/31': false}] という形式
 */
export const holidayArray = (fromDate, toDate, apiData) => {
  if (!_.isDate(fromDate) || !_.isDate(toDate)) {
    throw new Error('holidayArray args(fromDate, toDate) is not Date Type.');
  }
  if (fromDate > toDate) {
    throw new Error('holidayArray args(fromDate, toDate) is fromDate > toDate');
  }
  if (!Array.isArray(apiData)) {
    throw new Error('holidayArray args(apiData) is miss.');
  }

  // 日数
  const dayInterval =
    (toDate.getTime() - fromDate.getTime()) / (24 * 60 * 60 * 1000) + 1;

  // 日数でループする
  const holidays = [];
  for (let i = 0; i <= dayInterval - 1; i += 1) {
    const theDay = new Date(fromDate.getTime());
    theDay.setDate(fromDate.getDate() + i);

    const dateInfo = apiData.find(
      dateInfoObject =>
        dateInfoObject.work_date === util.dataFormat(theDay, 'YYYY/MM/DD')
    );
    const holidayFlag = _.isUndefined(dateInfo)
      ? false
      : dateInfo.holiday_flag === 1;
    holidays.push({
      date: [util.dataFormat(theDay, 'YYYY/MM/DD')],
      holiday: holidayFlag,
    });
  }
  return holidays;
};

/**
 * 指定日付以降の稼働日を求める。
 * 30日後まで調べて稼働日がない場合は翌日を返す。
 * @param {String} fieldId 場所のID
 * @param {Date} [theDay = new Date()]  指定日付 デフォルトは今日
 */
export const getNextDay = async function(feildId, theDay = new Date()) {
  const nextDay = util.getDay({ theDay, after: 1 });
  const afterOneMonthDay = util.getDay({ theDay, after: 30 });
  const parameter = {
    date_from: util.dataFormat(nextDay, 'YYYY/MM/DD'),
    date_to: util.dataFormat(afterOneMonthDay, 'YYYY/MM/DD'),
  };

  let workNextDay = nextDay; // 既定値は翌日

  // APIから情報取得
  let workDateList = null;
  await WorkDatesService.list(feildId, parameter)
    .then(response => {
      workDateList = response.data.entities.work_dates;
    })
    .catch(() => {
      console.log('WorkDatesService.list', '404 Error');
    });

  if (workDateList === null) {
    return null;
  }

  // 稼働日情報はAPIから
  // [{id, field_id, work_date: 'yyyy/mm/dd', holiday_flag: 0 | 1}, {同じ}]
  // という形式で取得できるが日付や空配列が取得される場合もあるので
  // その日が非稼働日かどうかを判定することにしておくべき
  const holidays = holidayArray(nextDay, afterOneMonthDay, workDateList);
  const workDateIndex = holidays.findIndex(
    element => element.holiday === false
  );
  if (workDateIndex !== -1) {
    workNextDay.setDate(workNextDay.getDate() + workDateIndex);
  }
  return workNextDay;
};

/**
 * 指定日付以前の稼働日を求める。
 * 30日前まで調べて稼働日がない場合は前日を返す。
 * @param {String} fieldId 場所のID
 * @param {Date} [theDay = new Date()]  指定日付 デフォルトは今日
 */
export const getPrevDay = async function(feildId, theDay = new Date()) {
  const prevDay = util.getDay({ theDay, after: -1 });
  const beforeOneMonthDay = util.getDay({ theDay, after: -30 });
  const parameter = {
    date_from: util.dataFormat(beforeOneMonthDay, 'YYYY/MM/DD'),
    date_to: util.dataFormat(prevDay, 'YYYY/MM/DD'),
  };

  let workPrevDay = prevDay; // 既定値は前日

  // APIから情報取得
  let workDateList = getProperty(
    await api.getWorkDatelist(feildId, parameter),
    'data.entities.work_dates'
  );
  // console.log('getPrevDay', workDateList, feildId, parameter);

  const holidays = holidayArray(
    beforeOneMonthDay,
    prevDay,
    workDateList
  ).reverse();
  const workDateIndex = holidays.findIndex(
    element => element.holiday === false
  );
  if (workDateIndex !== -1) {
    workPrevDay.setDate(workPrevDay.getDate() - workDateIndex);
  }
  return workPrevDay;
};



// WEBPACK FOOTER //
// ./src/canvas/common/works.js